import React from "react";
import "./observationTextDetail.css";
import { formatDate } from "../../service/constants";
const ObservationTextDetail = ({ observationDetailsData }) => {
  return (
    <div className="info-container">
      {observationDetailsData?.resource?.category && (
        <div>
          <span className="label">Category -</span>{" "}
          {observationDetailsData?.resource.category[0]?.text}
        </div>
      )}
      {!observationDetailsData.resource.code.coding && (
        <div>
          <span className="label">Test - </span>
          {observationDetailsData?.resource?.code?.text}
        </div>
      )}
      {observationDetailsData.resource.code.coding && (
        <div>
          <span className="label">Test - </span>
          {observationDetailsData?.resource?.code?.coding[0].display}
        </div>
      )}
      {/* {observationDetailsData?.resource?.code?.coding &&
        observationDetailsData?.resource?.code?.coding[0]?.display &&
        observationDetailsData?.resource?.code?.text && (
          <div>
            <span className="label">Test -</span>{" "}
            {observationDetailsData?.resource?.code?.coding[0]?.display}
          </div>
        )}
      {!observationDetailsData?.resource?.code?.coding &&
        !observationDetailsData?.resource?.code?.coding[0]?.display && (
          <div>
            <span className="label">Test -</span>{" "}
            {observationDetailsData?.resource?.code?.text}
          </div>
        )} */}
      {observationDetailsData?.resource?.code?.coding &&
        observationDetailsData?.resource?.code?.coding[0] &&
        observationDetailsData?.resource?.code?.coding[0]?.code && (
          <div>
            <span className="label">Snowmed - </span>
            {observationDetailsData?.resource?.code?.coding[0]?.code}
          </div>
        )}
      {observationDetailsData?.resource?.effectiveDateTime && (
        <div>
          <span className="label">Date -</span>{" "}
          {formatDate(observationDetailsData?.resource?.effectiveDateTime)}
        </div>
      )}
      {observationDetailsData?.resource?.valueQuantity && (
        <div>
          <span className="label">Result Value -</span>{" "}
          {observationDetailsData?.resource?.valueQuantity.value}
          {observationDetailsData?.resource?.valueQuantity?.unit}
        </div>
      )}
      {observationDetailsData?.resource?.referenceRange && (
        <div>
          <span className="label">Reference Range -</span>{" "}
          {observationDetailsData?.resource?.referenceRange[0].low.value}
          {observationDetailsData?.resource?.referenceRange[0].low.unit} -{" "}
          {observationDetailsData?.resource?.referenceRange[0].high.value}
          {observationDetailsData?.resource?.referenceRange[0].high.unit}
        </div>
      )}
      {observationDetailsData.resource.interpretation && (
        <div>
          <span className="label">Result -</span>{" "}
          {observationDetailsData.resource?.interpretation[0].coding[0].display}
        </div>
      )}

      {observationDetailsData.resource.valueCodeableConcept && (
        <div>
          <span className="label">Result -</span>{" "}
          {observationDetailsData.resource.valueCodeableConcept.text}
        </div>
      )}
      {observationDetailsData.resource.component &&
        observationDetailsData.resource.component.map((item) => (
          <div>
            <span className="label">{item.code.text} - </span>
            {item.valueQuantity.value} {item.valueQuantity.unit}
          </div>
        ))}
    </div>
  );
};

export default ObservationTextDetail;
